import {RootState} from 'store'

export const getAnsweredIds = (state: RootState): string[] => state.game.answeredIds

export const getProgress = (state: RootState): number => state.game.progress

export const getCountRiddles = (state: RootState): number => state.game.countRiddles

export const getIsFullProgress = (state: RootState): boolean => state.game.isFullProgress

export const getShowCongratulateModal = (state: RootState): boolean => state.game.showCongratulateModal

export const isLoading = (state: RootState): boolean => state.game.loadingGame
